import { z } from 'zod';
import type { PlaceCategory } from '@cobu/types';
import { Strings } from '../constants/Strings';

const PLACE_CATEGORIES: [PlaceCategory, ...PlaceCategory[]] = ['food', 'coffee', 'outdoor', 'shop'];

// A factory (not a const) so validation messages resolve in the active language
// at the time the form is built.
export const createPlaceSchema = () => {
  const v = Strings.get().places.validation;
  return z.object({
    name: z.string().trim().min(1, v.nameRequired).max(100, v.nameTooLong),
    street: z.string().trim().min(1, v.streetRequired),
    city: z.string().trim().min(1, v.cityRequired),
    zip: z.string().trim().min(1, v.zipRequired),
    category: z.enum(PLACE_CATEGORIES, { required_error: v.categoryRequired }),
    description: z.string().trim().max(500, v.descriptionTooLong).optional(),
  });
};

export type PlaceFormValues = z.infer<ReturnType<typeof createPlaceSchema>>;

export const placeDefaultValues: PlaceFormValues = {
  name: '',
  street: '',
  city: '',
  zip: '',
  category: 'food',
  description: '',
};
